/**
 * What a new map is called.
 *
 * "Genograma" alone is what every map in a practice would be called, which is
 * no name at all once there are three of them. The subject's name is what a
 * therapist is actually looking for in a list, so it goes in the title — and
 * the title stays editable, because the therapist may want to say something
 * else entirely ("Familia materna", "Antes de la separación").
 */

import { MAX_TITLE_LENGTH } from "./types";

const SEPARATOR = " - ";

export const mapTitle = (kindLabel: string, subject?: string | null): string => {
    const name = (subject ?? "").trim();
    if (!name) return kindLabel;

    const room = MAX_TITLE_LENGTH - kindLabel.length - SEPARATOR.length;
    // A name with nowhere to go leaves the kind on its own rather than a title
    // cut down to an initial.
    if (room < 4) return kindLabel;

    const fitted =
        name.length > room ? `${name.slice(0, room - 1).trimEnd()}…` : name;
    return `${kindLabel}${SEPARATOR}${fitted}`;
};
